<template>
  <div class="header">
    {{ $route.meta.title }}

    <a-select
      :value="cycle_id"
      class="window-select"
      placeholder="Please Select"
      @change="handleChange"
    >
      <a-select-option
        v-for="cycle in cycles"
        :key="cycle.id"
        :value="cycle.id"
      >
        {{ cycle.period_name }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
  import { getCycleList } from '@/api/admin'
  export default {
    name: 'DashboardHeader',
    data() {
      return {
        cycles: [],
        cycle_id: undefined,
      }
    },
    mounted() {
      this.load()
    },
    methods: {
      async load() {
        try {
          const res = await getCycleList()
          this.cycles = res.data.filter((period) => period.employee_counts > 0)
          const activeCycle = this.cycles.find((el) => el.status === 1)
          this.cycle_id = activeCycle ? activeCycle.id : this.cycles.length > 0 ? this.cycles[0].id : undefined
        } catch (error) {
          console.log(error)
        }
      },
      handleChange(cycle_id) {
        this.cycle_id = cycle_id
        this.$emit('queryWindow', cycle_id)
      },
    },
  }
</script>

<style lang="less" scoped>
  .header {
    background-color: white;
    font-size: 22px;
    font-weight: 600;
    padding: 28px 31px 19px 31px;
    line-height: 31px;
    display: flex;
    align-items: center;

    .window-select {
      margin-left: 20px;
      width: 384px;
      font-size: 18px;
      font-weight: 500;

      /deep/ .ant-select-selector {
        border: none;
        background-color: #f8f8f8;
        font-weight: 500;
      }
    }
  }
</style>
